import { render, staticRenderFns } from "./RelationDetailAppointments.vue?vue&type=template&id=68fa43a2"
import script from "./RelationDetailAppointments.vue?vue&type=script&lang=ts"
export * from "./RelationDetailAppointments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports